export default __webpack_public_path__ + "static/media/features-mock-slide3-dashboard@2x.593eff46.png";